import { Order } from "./Order";
import { PartnerStockRow, ProductInventoryInfo } from "./Product";

export class ShoppingCart {
    UserId?: string;
    ImpactPartnerId?: string;
    CartId: string;
    CartName: string;
    CartCreated?: Date;
    CartModified?: Date;
    Items?: ShoppingCartItem[];
    GroupInner?: Record<string, ShoppingCartItem[]>;
    TotalCount?: number;
    TotalQuantity?: number;
    Orders?: Order[];
    Status?: Status;
    StatusModifiedDate?: Date;
}

export class ShoppingCartItem {
    CartItemId?: string;
    CartId?: string;
    ProductShortCode?: string;
    ProductNumber: string
    Description: string;
    Remanufactured: boolean;
    PartnerId: string;
    PartnerName: string;
    PartnerPartNumber: string;
    PricePerUnit: number;
    OldPricePerUnit?: number;
    PricePerUnitUpdatedDate?: Date;
    Amount: number;
    OldAmount?: number;
    ApprovedBy?: string;
    PartnerFormatedName?: string;
    OrderCutoffTime?: string;
    OrderProcessingTime?: string;
    Available: boolean;
    PartnerStock?: PartnerStockRow;
    Inventory?: ProductInventoryInfo;
    QuantityErrorMessage?: string;
}

export class ShoppingCartSettings {
    PageSize: number;
    IsDebugMode: boolean;
}

export enum Status {
    None = "None",
    Pending = "Pending",
    Confirmed = "Confirmed",
}
